const courses = {
  courses: 'Courses',
  coursesList: 'Courses List',
  name: 'Name',
  grade: 'Grade',
  section: 'Section',
  joinCode: 'Join Code',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  total: 'Total',
  studentCount: 'Students',
  courseName: 'Course name',
  filterByGrade: 'Filter by grade',
  filterByStatus: 'Filter by status',
  search: 'Search',
  deactivate: 'Deactivate',
  activate: 'Activate',
  confirmDeactivate: 'Confirm deactivation',
  confirmActivate: 'Confirm activation',
  deactivateWarning: 'By deactivating this course, students will not be able to access it until it is reactivated.',
  activateInfo: 'By activating this course, students will be able to access it again.',
  hasActiveStudentsWarning: 'This course has active students. By deactivating it, they will lose access to the content.',
  courseActivated: 'Course activated successfully',
  courseDeactivated: 'Course deactivated successfully',
  errorLoadingCourses: 'Error loading courses',
  errorUpdatingCourse: 'Error updating course',
  errorActivating: 'Error activating course',
  errorDeactivating: 'Error deactivating course',
  codeCopied: 'Code copied to clipboard',
  errorCopyingCode: 'Error copying code',
};

export default courses;
